var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.specialCloudShow,
          expression: "specialCloudShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _vm.cloudInfo
        ? _c(
            "div",
            {
              staticClass: "content",
              class:
                _vm.cloudInfo &&
                (_vm.cloudInfo.appName == "gSuite" ||
                  _vm.cloudInfo.appName == "gSuiteSharedDrive")
                  ? "addSpecialCloud"
                  : "addOtherSpecialCloud"
            },
            [
              _c("div", { staticClass: "title" }, [
                _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("language.common.add")) +
                      " " +
                      _vm._s(
                        _vm.$t("language.addCloud." + _vm.cloudInfo.appName)
                      )
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "icon white-close dialog-close",
                  on: {
                    click: function($event) {
                      ;(_vm.specialCloudShow = false), (_vm.cloudInfo = "")
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "add-special-cloud-cont" }, [
                _vm.cloudInfo &&
                (_vm.cloudInfo.appName == "gSuite" ||
                  _vm.cloudInfo.appName == "gSuiteSharedDrive")
                  ? _c("span", [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("language.popup.addCloudPopup.specialgSuite")
                          )
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.cloudInfo && _vm.cloudInfo.appName == "dropbox4Business"
                  ? _c("span", [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "language.popup.addCloudPopup.specialDropBox"
                            )
                          )
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.cloudInfo && _vm.cloudInfo.appName == "oneDrive4Business"
                  ? _c("span", [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "language.popup.addCloudPopup.specialOnedrive"
                            )
                          )
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.cloudInfo && _vm.cloudInfo.appName == "boxBusiness"
                  ? _c("span", [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "language.popup.addCloudPopup.specialBoxBusiness"
                            )
                          )
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticStyle: { "margin-top": "20Px" },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "language.popup.addCloudPopup.specialDropBoxBottom"
                      )
                    )
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: [
                      _vm.cloudInfo &&
                      (_vm.cloudInfo.appName == "gSuite" ||
                        _vm.cloudInfo.appName == "gSuiteSharedDrive")
                        ? "special-bottom-botton"
                        : "special-obottom-botton",
                      _vm.cloudInfo &&
                      _vm.cloudInfo.appName == "gSuite" &&
                      _vm.languageArr.includes(_vm.$i18n.locale)
                        ? "special-cbottom-botton"
                        : "",
                      _vm.cloudInfo &&
                      (_vm.cloudInfo.appName == "gSuite" ||
                        _vm.cloudInfo.appName == "gSuiteSharedDrive") &&
                      _vm.otherLanguageArr.includes(_vm.$i18n.locale)
                        ? "special-tbottom-botton"
                        : ""
                    ]
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "special-botton special-botton-left",
                        on: {
                          click: function($event) {
                            return _vm.addOra(1)
                          }
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.leftconnect,
                                expression: "leftconnect"
                              }
                            ]
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("language.common.connecting")) +
                                "\n            "
                            ),
                            _c("span", { staticClass: "cloudDotting" })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.leftconnect,
                                expression: "!leftconnect"
                              }
                            ]
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.addCloudPopup.accessOrganization"
                                  )
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "special-botton special-botton-right",
                        on: {
                          click: function($event) {
                            return _vm.addOra(2)
                          }
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.rightconnect,
                                expression: "rightconnect"
                              }
                            ]
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("language.common.connecting")) +
                                "\n            "
                            ),
                            _c("span", { staticClass: "cloudDotting" })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.rightconnect,
                                expression: "!rightconnect"
                              }
                            ]
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.addCloudPopup.accessPersonalCloud"
                                  )
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0466441e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0466441e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/add_cloud_popups/add_special_cloud_popup.vue
// module id = null
// module chunks = 